export default __webpack_public_path__ + "static/media/green_check.fb95789d.svg";